export default "__VITE_ASSET__CizUCuvG__"